// extracted by mini-css-extract-plugin
module.exports = {"project_title":"Project_project_title__2t3ya","project_link":"Project_project_link__83YjT"};